<template>
  <v-container fluid class="mt-4 mt-sm-16">
    <v-img
      :src="require('@/assets/image/logo.svg')"
      class="d-block mx-auto mb-5"
      contain
      height="30"
    />

    <transitionPage>
      <router-view :key="$route.path" />
    </transitionPage>
  </v-container>
</template>

<script>
import TransitionPage from "@/components/TransitionPage/index";

export default {
  name: "auth-layout",
  components: { TransitionPage },
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
@import "Auth";
</style>
